/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Submitticketsize_Modal_Maxinputlabel5Inputs */

const en_coinvestments_submitticketsize_modal_maxinputlabel5 = /** @type {(inputs: Coinvestments_Submitticketsize_Modal_Maxinputlabel5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum`)
};

/**
* | output |
* | --- |
* | "Maximum" |
*
* @param {Coinvestments_Submitticketsize_Modal_Maxinputlabel5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_submitticketsize_modal_maxinputlabel5 = /** @type {((inputs?: Coinvestments_Submitticketsize_Modal_Maxinputlabel5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Submitticketsize_Modal_Maxinputlabel5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_submitticketsize_modal_maxinputlabel5(inputs)
});
export { coinvestments_submitticketsize_modal_maxinputlabel5 as "coInvestments_submitTicketSize_modal_maxInputLabel" }